<osapp-selector [params]="params" (selectionValidated)="onSelectionValidated($event)" [values]="values">
</osapp-selector>